export const cloudspongeSupportedProviders = [
  'gmail', 'yahoo', 'windowslive', 'aol', 'icloud',
  'gmx', 'web_de', 'bol', 'terra', 'uol',
  'mailcom', 'rediff', 'sapo', 'naver', 'poczta_o2'
];

export const providerGroups = {
  default: ['gmail', 'yahoo', 'windowslive', 'csv'],
  custom: ['gmail', 'yahoo', 'windowslive'],
  microsoft: ['windowslive', 'gmail', 'yahoo', 'csv'],
  apple: ['icloud', 'addressbook','gmail', 'csv'],
  de: ['gmx', 'web_de', 'gmail', 'yahoo'],
  br: ['bol', 'terra', 'uol', 'gmail']
}

export const cloudspongeProviderMap = {
  gmail: { group: providerGroups.default, canLaunch: true },
  yahoo: { group: providerGroups.default, canLaunch: true },
  aol: { group: ['aol'].concat(providerGroups.custom), canLaunch: true },
  mailcom: { group: ['mailcom'].concat(providerGroups.custom), canLaunch: true },
  rediff: { group: ['rediff'].concat(providerGroups.custom), canLaunch: true },
  sapo: { group: ['sapo'].concat(providerGroups.custom), canLaunch: true },
  naver: { group: ['naver'].concat(providerGroups.custom), canLaunch: true },
  poczta_o2: { group: ['poczta_o2'].concat(providerGroups.custom), canLaunch: true },
  outlookcom: { group: providerGroups.microsoft, canLaunch: true },
  windowslive: { group: providerGroups.microsoft, canLaunch: true },
  outlook: { group: providerGroups.microsoft, canLaunch: true },
  icloud: { group: providerGroups.apple, canLaunch: false },
  gmx: { group: providerGroups.de, canLaunch: true },
  web_de: { group: providerGroups.de, canLaunch: true },
  bol: { group: providerGroups.br, canLaunch: true },
  terra: { group: providerGroups.br, canLaunch: true },
  uol: { group: providerGroups.br, canLaunch: true }
}